"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSENT_RESPONSE_EXAMPLE = void 0;
exports.CONSENT_RESPONSE_EXAMPLE = {
    id: '55555555-5555-5555-5555-555555555555',
    tenantId: '11111111-1111-1111-1111-111111111111',
    patientId: '22222222-2222-2222-2222-222222222222',
    consentType: 'TREATMENT',
    scopeDescription: 'General consent for OPD consultation and diagnostic tests',
    grantedByGuardianId: null,
    signatureId: null,
    status: 'ACTIVE',
    validFrom: '2026-07-10T09:00:00.000Z',
    validTo: null,
    revokedAt: null,
    revokedReason: null,
    createdAt: '2026-07-10T09:00:00.000Z',
    updatedAt: '2026-07-10T09:00:00.000Z',
};
//# sourceMappingURL=consent.response.js.map